module.exports = __webpack_public_path__ + "static/mm-snap-d1ec99ab43a25d89ba1068b4e59b2751.gif";